import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { SessionAnatomy } from './components/SessionAnatomy';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-light text-ink font-sans selection:bg-shuttle selection:text-ink" data-id="element-0" data-mp="3mjq2zht18ww4">
      <MetaPixel data-id="element-1" data-mp="5yimri0b7dt" />
      <main data-id="element-2" data-mp="6hp9c27i9cj">
        <Hero data-id="element-3" data-mp="682rygdekbl" />
        <SocialProofBar data-id="element-4" data-mp="4n6o4eeqtbm" />
        <PainGrid data-id="element-5" data-mp="82kl3wchwbg" />
        <ProductReveal data-id="element-6" data-mp="2zl3bdjx5744s" />
        <Tomes data-id="element-7" data-mp="2zlv6ktmtuzuj" />
        <LookInside data-id="element-8" data-mp="2zm4v0cs84yy4" />
        <Bonuses data-id="element-9" data-mp="2zmwi0z7r9ocs" />
        <ValueStack data-id="element-10" data-mp="2zng14j956ise" />
        <Urgency data-id="element-11" data-mp="33mf1dqjxhrdi" />
        <Pricing data-id="element-12" data-mp="33lwzadal4ixo" />
        {shortTestimonials.length > 0 ? <Testimonials testimonials={shortTestimonials} background="white" data-id="element-13" data-mp="33ohzyyz5cstu" /> : <WhoItsFor data-id="element-14" data-mp="38o4fxg6d0n6c" />}
        <Guarantee data-id="element-15" data-mp="3dle3eqa6uorj" />
        <Faq data-id="element-16" data-mp="3dlw4q1bpjt6b" />
        {moreTestimonials.length > 0 ? <Testimonials testimonials={moreTestimonials} title="More groups, more settings" background="light" data-id="element-17" data-mp="nvj35ett6cp7" /> : <SessionAnatomy data-id="element-18" data-mp="ssssyvl40qdk" />}
        <CostOfInaction data-id="element-19" data-mp="36861i5q6iv0" />
        <Close data-id="element-20" data-mp="35gld2do25ji" />
      </main>
      <Footer data-id="element-21" data-mp="34nbhsjeuzx5" />
      <PurchaseNotifications data-id="element-22" data-mp="38b5essrpoce" />
    </div>;
}